// Shared mobile-viewport detection for the deck engine, mobile module, and DeckViewer.
// window.innerWidth can transiently report 0 during initial load in embedded
// browser contexts (before emulation applies); a bare `innerWidth <= 768` check
// misreads that as mobile and breaks desktop navigation. Treat an unmeasurable
// width as desktop, falling back to screen.width so a real phone still gets
// scroll mode.

export const MOBILE_BREAKPOINT = 768;

export function isMobileViewport() {
  const width = window.innerWidth || document.documentElement.clientWidth || 0;
  if (width > 0) return width <= MOBILE_BREAKPOINT;
  const screenWidth = window.screen?.width || 0;
  return screenWidth > 0 && screenWidth <= MOBILE_BREAKPOINT;
}
